import { captureSubmitError } from './captureSubmitError'
import { captureSubmitPerformance } from './captureSubmitPerformance'
import { forwardTo } from '../default/forwardTo'
import { verifyCodeVeracity } from '../middleware/verifyCodeVeracity.js'
import { updateSession } from '../default/updateSession'

/**
 * Submits code and get's user data
 * @param {string} code - The otp code
 * @param {string} phone - The phone
 * @param {string} [redirect] - The success redirect
 * @returns {Promise<boolean|undefined>}
 */
export async function submitCodeVeracity(code, phone, redirect) {
  const startTime = performance.now()
  try {
    const data = await verifyCodeVeracity(code, phone)
    const firstName = data.first_name || ''
    const lastName = data.last_name || ''
    const mainEmail = data.email || ''
    const birthDate = data.dob || ''
    const mainAddressLine = data.address_1 || ''
    const mainCity = data.city || ''
    const mainState = data.state || ''
    const mainZipCode = data.zip_code || ''

    const SESSION_ID = 'tdMainFunnel'
    updateSession(SESSION_ID, 'firstName', firstName)
    updateSession(SESSION_ID, 'lastName', lastName)
    updateSession(SESSION_ID, 'mainEmail', mainEmail)
    updateSession(SESSION_ID, 'birthdate', birthDate) // returns as year-month-day
    updateSession(SESSION_ID, 'mainAddressLine', mainAddressLine)
    updateSession(SESSION_ID, 'mainCity', mainCity)
    updateSession(SESSION_ID, 'mainState', mainState)
    updateSession(SESSION_ID, 'mainZipCode', mainZipCode)

    if (!data || Object.keys(data).length === 0) {
      throw new Error('No user data received from verification')
    }

    captureSubmitPerformance(performance.now() - startTime)
    if (redirect) {
      forwardTo(redirect)
      return true
    }

    return true
  } catch (error) {
    captureSubmitPerformance(performance.now() - startTime)
    captureSubmitError(/** @type {Error} */ (error), false)
    return false
  }
}
